























































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositInterestSettings from '@/models/Products/ProductSettings/DefaultSettings/DepositInterest/DepositInterestSettings';
import DepositInterestSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/DepositInterest/DepositInterestSettingsEditDialog.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import PeriodType from '@/models/Shared/PeriodType';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositInterestSettingsRead', components: { ProductState, DepositInterestSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositInterestSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

    get rateSourceRate() {
        // This is not currently provided in the API so calculate it manually
        return this.settings.cumulativeRateValue - this.settings.rateValue;
    }

    get cumulativeRateCalculationText() {
        // A text representation of the cumulative rate calculation
        return `${this.settings.rateSourceIdentifier.entityName} ${this.rateSourceRate}% + ${this.$t('pageText.products.fields.rateValue')} ${this.settings.rateValue}%`;
    }

    get isFixedSchedule() {
        return this.settings.postingScheduleType === PostingScheduleType.FixedSchedule;
    }

}
